export const PAYCO_PAY_TYPE = {
  PAYCO: 'PAYCO',
};
